import { addIcons } from 'ionicons';
import {
  add,
  addCircleOutline,
  albumsOutline,
  arrowBack,
  arrowDownCircleOutline,
  arrowForward,
  bookmark,
  bookmarkOutline,
  bus,
  calendar,
  calendarOutline,
  cart,
  cartOutline,
  cash,
  checkmarkOutline,
  chevronDown,
  chevronForward,
  close,
  cloudDownloadOutline,
  code,
  flagOutline,
  heart,
  heartCircle,
  heartOutline,
  helpBuoyOutline,
  home,
  informationCircle,
  informationCircleOutline,
  locate,
  location,
  locationOutline,
  lockClosed,
  lockOpenOutline,
  logOut,
  logoEuro,
  mail,
  map,
  mapOutline,
  navigate,
  notifications,
  person,
  qrCodeOutline,
  remove,
  removeCircleOutline,
  search,
  searchOutline,
  ticket,
  time,
  timeOutline,
  trash,
  warning,
} from 'ionicons/icons';

/**
 * ion-icon resolves `name="..."` icons by fetching their SVG over HTTP at
 * runtime. That fetch is unreliable inside the iOS WKWebView (icons render
 * fine on web/Android but come up blank on native iOS). Registering the SVG
 * data up front bundles it into the JS, so every <ion-icon name> in the app
 * resolves locally with no runtime fetch, on every platform.
 */
export function registerAppIcons(): void {
  addIcons({
    add,
    'add-circle-outline': addCircleOutline,
    'albums-outline': albumsOutline,
    'arrow-back': arrowBack,
    'arrow-down-circle-outline': arrowDownCircleOutline,
    'arrow-forward': arrowForward,
    bookmark,
    'bookmark-outline': bookmarkOutline,
    bus,
    calendar,
    'calendar-outline': calendarOutline,
    cart,
    'cart-outline': cartOutline,
    cash,
    'checkmark-outline': checkmarkOutline,
    'chevron-down': chevronDown,
    'chevron-forward': chevronForward,
    close,
    'cloud-download-outline': cloudDownloadOutline,
    code,
    'flag-outline': flagOutline,
    heart,
    'heart-circle': heartCircle,
    'heart-outline': heartOutline,
    'help-buoy-outline': helpBuoyOutline,
    home,
    'information-circle': informationCircle,
    'information-circle-outline': informationCircleOutline,
    locate,
    location,
    'location-outline': locationOutline,
    'lock-closed': lockClosed,
    'lock-open-outline': lockOpenOutline,
    'log-out': logOut,
    'logo-euro': logoEuro,
    mail,
    map,
    'map-outline': mapOutline,
    navigate,
    notifications,
    person,
    'qr-code-outline': qrCodeOutline,
    // 'qr-scanner' is not a real Ionicon name; mapped to the closest valid icon.
    'qr-scanner': qrCodeOutline,
    remove,
    'remove-circle-outline': removeCircleOutline,
    search,
    'search-outline': searchOutline,
    ticket,
    time,
    'time-outline': timeOutline,
    trash,
    warning,
  });
}
